import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { UserListContainerComponent } from '@fi-app/user/user-list-container/user-list-container.component';

export const FiCoreUserListState: Ng2StateDeclaration = {
    name: FiStateNames.User.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:selectedTags&:offset&:UserId',
    params: {
        searchObjects: null,
        //UserId: null,
    },
    component: UserListContainerComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiCoreUserListStateResolve_pageTitle],
        initialSearchObjects: [FiStateService, Transition, FiCoreUserListStateResolve_initialSearchObjects],
    },
    data: {
        addSref: FiStateNames.User.AddV2,
    },
};

export function FiCoreUserListStateResolve_pageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByItem(ObjectTypes.User);
}

export function FiCoreUserListStateResolve_initialSearchObjects(
    fiStateService: FiStateService,
    transition: Transition,
) {
    const searchObjects = fiStateService.getParams(transition).searchObjects;
    return searchObjects;
}
